// hooks
import { useCommonQuery } from 'hooks';

// modules
import { type ChardDashboardOverview } from '../models';
import type { BaseApiResponse, CommonQueryOptions, ResultError } from 'modules';

// apis
import { DashboardAPI } from '../apis/chart-dashboard.api';

// keys
import { dashboardKeys } from '../keys/dashboard.key';

export const dashboardAPI = new DashboardAPI();

/** Chart Dashboard 데이터 조회 쿼리 훅 */
export const useGetChartDashboardData = ({
  data,
  options
}: {
  data: string;
  options?: CommonQueryOptions<
    BaseApiResponse<ChardDashboardOverview>,
    ResultError,
    ChardDashboardOverview
  >;
}) => {
  const queryKeyFactory = () => dashboardKeys.GET_CHART_DASHBOARD_DATA();

  const queryFn = async () => {
    return await dashboardAPI.getChartDashboardData();
  };

  return useCommonQuery<
    string,
    BaseApiResponse<ChardDashboardOverview>,
    ResultError,
    ChardDashboardOverview
  >({
    data,
    options: {
      ...options,
      select: (data) => data.resultObject
    },
    queryKeyFactory,
    queryFn
  });
};
